import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent, Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import DateTime from '_class/DateTime';
import swal from 'sweetalert2';
import { addComment, updateStudentAdjustment, deleteStudentAdjustment } from 'actions/additional_adjustments';
import EditAdditionalAdjustmentSubjects from '../Form/EditAdditionalAdjustmentSubjects';
import EditStudentAdjustmentForm from '../Form/EditStudentAdjustmentForm';
import PostContent from 'components/Presentation/PostContent';
import Modal from 'containers/Modals/Modal';
import Comments from './Partials/Comments';
import { Collapsible } from 'UI';
import { Icon, Flex, Button } from '@haldor/ui';

var AdditionalAdjustmentModal = /*#__PURE__*/function (_Component) {
  _inherits(AdditionalAdjustmentModal, _Component);

  var _super = _createSuper(AdditionalAdjustmentModal);

  function AdditionalAdjustmentModal(props) {
    var _this;

    _classCallCheck(this, AdditionalAdjustmentModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleCourseModal", function (adjustment) {
      if (adjustment == null) {
        _this.setState({
          subjectsModal: null
        });
      } else {
        var clonedAdjustment = JSON.parse(JSON.stringify(adjustment));

        _this.setState({
          subjectsModal: clonedAdjustment
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEditModal", function (adjustment) {
      if (adjustment == null) {
        _this.setState({
          editModal: null
        });
      } else {
        var clonedAdjustment = JSON.parse(JSON.stringify(adjustment));

        _this.setState({
          editModal: clonedAdjustment
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAdjustmentSubmit", function (values) {
      return new Promise(function (resolve) {
        // Clean up properties that doesnt need to be sent to the api
        delete values.comments;
        delete values.courses;
        delete values.subjects;
        delete values.createdBy;
        delete values.editedBy;
        delete values.versions;
        delete values.student;

        _this.props.updateStudentAdjustment(values).then(function () {
          _this.setState({
            editModal: null
          });

          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteAdjustment", function (adjustment) {
      var translate = _this.props.translate;
      swal.fire({
        title: translate('Are you sure?'),
        text: translate('The adjustment will be removed from the student wherever it is used. Restoration can only be done by a special educational needs teacher.'),
        showCancelButton: true,
        cancelButtonText: translate('Cancel'),
        confirmButtonText: translate('Remove')
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (response.value != null) {
                    _this.props.deleteStudentAdjustment(adjustment);
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "addComment", function (values, adjustmentId) {
      return new Promise(function (resolve) {
        _this.props.addComment(values, adjustmentId).then(function () {
          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      if (_this.props.onClose != null) {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderAdjustment", function (adjustment) {
      var translate = _this.props.translate;
      var collapseTrigger = /*#__PURE__*/React.createElement("strong", {
        className: "trigger",
        style: {
          cursor: 'pointer'
        }
      }, /*#__PURE__*/React.createElement("span", null, _this.props.translate('subjects'), " ", adjustment.subjects.length), !_this.props.disableCommenting ? /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();

          _this.toggleCourseModal(adjustment);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      })) : null);
      return /*#__PURE__*/React.createElement("div", {
        key: adjustment.id,
        className: "adjustment adjustment-item",
        style: {
          marginBottom: '3rem'
        }
      }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PostContent, null, adjustment.description), /*#__PURE__*/React.createElement("div", {
        className: "createdBy color--meta"
      }, adjustment.createdBy.firstName, " ", adjustment.createdBy.lastName, ' • ' + new DateTime(adjustment.created).getShortDate(true), adjustment.subjects.length > 0 ? ' • ' : null, adjustment.subjects != null ? adjustment.subjects.map(function (subject, index) {
        var title = subject.title;

        if (index != adjustment.subjects.length - 1) {
          title += ', ';
        }

        return /*#__PURE__*/React.createElement("span", {
          className: "subject",
          key: subject.id
        }, title);
      }) : null)), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, _this.props.disableCommenting == true ? /*#__PURE__*/React.createElement(Comments, {
        form: 'comment-' + adjustment.id,
        adjustment: adjustment
      }) : /*#__PURE__*/React.createElement(Comments, {
        form: 'comment-' + adjustment.id,
        adjustment: adjustment,
        onSubmit: function onSubmit(values) {
          return _this.addComment(values, adjustment.id);
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "adjustment-meta size-14",
        style: {
          flexBasis: '25%'
        }
      }, adjustment.status == 'ACTIVE' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, translate('start-time')), /*#__PURE__*/React.createElement("br", null), new DateTime(adjustment.startDate).getShortDate()) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, translate('time-period')), /*#__PURE__*/React.createElement("br", null), new DateTime(adjustment.startDate).getShortDate(), ' - ' + new DateTime(adjustment.endDate).getShortDate()), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("strong", null, _this.props.translate('Status')), /*#__PURE__*/React.createElement("br", null), _this.props.translate(adjustment.status.toLowerCase())), /*#__PURE__*/React.createElement("div", {
        className: "meta-courses",
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: collapseTrigger
      }, adjustment.subjects != null ? adjustment.subjects.map(function (subject) {
        return /*#__PURE__*/React.createElement("div", {
          key: subject.id
        }, subject.title);
      }) : null)), !_this.props.disableCommenting ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          return _this.toggleEditModal(_objectSpread({}, adjustment));
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), " ", translate('Edit'))) : null, !_this.props.disableCommenting ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.5rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          return _this.deleteAdjustment(adjustment);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), " ", translate('Remove'))) : null)));
    });

    _this.state = {
      subjectsModal: null,
      editModal: null
    };
    return _this;
  }

  _createClass(AdditionalAdjustmentModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          adjustment = _this$props.adjustment,
          translate = _this$props.translate;

      if (adjustment == null) {
        return null;
      }

      var title = adjustment.title;

      if (adjustment.subTitle != null) {
        title += ' - ' + adjustment.subTitle;
      }

      return /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        onClose: this.onClose,
        isOpen: true,
        title: title
      }, /*#__PURE__*/React.createElement("div", {
        key: 'edit-subjects-modal'
      }, this.state.subjectsModal != null ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        onClose: function onClose() {
          return _this2.toggleCourseModal();
        },
        type: "small",
        title: translate('Subjects')
      }, /*#__PURE__*/React.createElement(EditAdditionalAdjustmentSubjects, {
        adjustment: this.state.subjectsModal,
        onClose: this.toggleCourseModal
      })) : null), this.state.editModal != null ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        onClose: function onClose() {
          return _this2.toggleEditModal();
        },
        title: translate('Edit adjustment')
      }, /*#__PURE__*/React.createElement(EditStudentAdjustmentForm, {
        adjustment: this.state.editModal,
        onClose: this.toggleEditModal,
        onSubmit: this.onAdjustmentSubmit
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '0 1.75em'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "adjustment teacher-items-adjustments"
      }, adjustment.items.map(function (student) {
        var activeItems = student.items.find(function (adjustment) {
          return adjustment.status == 'ACTIVE';
        });

        if (activeItems == null) {
          return null;
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "student",
          key: 'student-adjustment-' + student.userId
        }, /*#__PURE__*/React.createElement("h2", null, student.firstName, " ", student.lastName), student.items.map(function (adjustment) {
          if (adjustment.status != 'ACTIVE') {
            return null;
          }

          return _this2.renderAdjustment(adjustment);
        }));
      }))));
    }
  }]);

  return AdditionalAdjustmentModal;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  addComment: addComment,
  updateStudentAdjustment: updateStudentAdjustment,
  deleteStudentAdjustment: deleteStudentAdjustment
})(AdditionalAdjustmentModal);